import { usePropertyPlannedPlattedLots } from '../../../../queries/PropertyFields/NonRentalLandFields';
import { NumberBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

interface PlattedLotsPlannedProps {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const PlattedLotsPlanned: React.FC<PlattedLotsPlannedProps> = ({ propertyGuid, required, isReview = false }) => {
    const label = 'Planned number of platted lots';
    const [plannedPlattedLots, set_plannedPlattedLots] = usePropertyPlannedPlattedLots(propertyGuid);

    const handlePlannedPlattedLots = (newvalue: number) => {
        const result = Number(newvalue) || undefined;
        set_plannedPlattedLots(result);
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={plannedPlattedLots}
                />
            ) : (
                <NumberBox
                    id='plannedPlattedLots'
                    value={plannedPlattedLots}
                    onChange={handlePlannedPlattedLots}
                    label={label}
                    required={required}
                    width='220px'
                />
            )}
        </>
    );
};
